// extracted by mini-css-extract-plugin
export var editor = "_10-0";
export var flowSidebar = "_3v-2";